import React, { createContext, useContext, ReactNode } from 'react';
import { useTour } from '../hooks/useTour';
import { TourStep } from '../config/tourSteps';

// Interface do contexto do tour
interface TourContextType {
    isActive: boolean;
    currentStep: TourStep | null;
    currentStepIndex: number;
    totalSteps: number;
    shouldAutoStart: boolean;
    primeiroAcesso: boolean | null;  // ✅ Adicionado
    startTour: () => void;
    nextStep: () => void;
    previousStep: () => void;
    skipTour: () => void;
    completeTour: () => void;
    restartTour: () => void;
    getTourStatus: () => { completed: boolean; skipped: boolean; currentStepId: string | null };
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export const TourProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const tour = useTour();

    return (
        <TourContext.Provider value={tour}>
            {children}
        </TourContext.Provider>
    );
};

export const useTourContext = () => {
    const context = useContext(TourContext);
    if (context === undefined) {
        throw new Error('useTourContext must be used within a TourProvider');
    }
    return context;
};
